var map = {
	"./barbara.jpeg": 2526,
	"./beatriz-sabino.jpg": 354,
	"./catarina-silva.png": 2633,
	"./cristiane-fidelix.jpeg": 7554,
	"./gustavo-rodrigues.png": 6350,
	"./ines-calcoa.jpeg": 1416,
	"./ines-martins.jpg": 1990,
	"./ines-silvestre.jpg": 9343,
	"./inesmatos.png": 5929,
	"./isabel.jpg": 4494,
	"./miriam.jpg": 3643,
	"./monica.jpg": 1363,
	"./nuno-reis.png": 1762,
	"./pessoa1.png": 8586,
	"./ricardo.png": 8510,
	"./selmira.jpg": 6787,
	"./teresa-alves.jpg": 7082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2702;